module.exports = __webpack_public_path__ + "static/02a-a0ee22efa3f1e52efc3ce13bf3fd5c3c.jpg";